import React, { createContext, useCallback, useContext, useState } from 'react';
import { DealType } from '../types/deals';

type DealContextState = {
  currentDeal: DealType | null;
  dealId: string;
  setCurrentDeal: (deal: DealType | null) => void;
};

const DealContext = createContext<DealContextState | undefined>(undefined);
DealContext.displayName = 'DealContext';

export const DealProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [currentDeal, setCurrentDealState] = useState<DealType | null>(null);

  const setCurrentDeal = useCallback((deal: DealType | null) => {
    setCurrentDealState(deal);
  }, []);

  const dealId = currentDeal?.id || '';

  return (
    <DealContext.Provider value={{ currentDeal, dealId, setCurrentDeal }}>
      {children}
    </DealContext.Provider>
  );
};

export function useDeal(): DealContextState {
  const context = useContext(DealContext);
  if (!context) {
    throw new Error('useDeal must be used within a DealProvider');
  }
  return context;
}
